import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import Table from "../../../core/common/dataTable/index";
import Swal from "sweetalert2";
import useApi from "../../../core/customhook/useApi";
import dayjs from "dayjs";
import { useState } from "react";
import Loader from "../../../core/common/selfLoder";
import { getFinancialYearList } from "../../../core/common/financialYear";

const OutdutyTeamStatus = () => {
  const [selectedRows, setSelectedRows] = useState<any[]>([])
  const [refreshKey, setRefreshKey] = useState(0);
  const [modalData, setModalData] = useState<any>({});
  const [leavestatus, setLeavestatus] = useState("PENDING");
  const formatLongDate = (date?: string) =>
    date ? dayjs(date).format("D MMMM YYYY") : "------";

  const formatFinancialYear = (year: number) => {
    const nextYearShort = (year + 1).toString().slice(-2);
    return `${year}-${nextYearShort}`;
  };

  const getFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    return formatFinancialYear(year);
  };

  const [finance_year, setFinance_year] = useState(getFinancialYear());

  const handleLeaveStatusChange = (value: string) => {
    setLeavestatus(value);
  };

  const {
    data: odData,
    loading: odLoading,
    error: odError,
  } = useApi("/api/manager/view-od-request", {
    method: "POST",
    autoCall: true,
    payload: {
      financial_year: finance_year,
      status: leavestatus,
    },
    dependencies: [leavestatus, refreshKey ,finance_year],
  });

  // const data = odData?.data.map((item: any, index: number) => {
  //   return {
  //     ...item,
  //     Days: item.days === null ? "------" : item.days,
  //   };
  // });

  const data = odData?.success
    ? odData.data.map((item: any) => ({
      ...item,
      Days: item.days ?? "------",
    }))
    : [];

  const columns = [
    {
      title: "Emp Id",
      dataIndex: "employee_id",
      sorter: (a: any, b: any) => a.employee_id.localeCompare(b.employee_id),
    },
    {
      title: "Employee",
      dataIndex: "employee_name",
      sorter: (a: any, b: any) =>
        a.employee_name.localeCompare(b.employee_name),
    },
    {
      title: "App Date",
      dataIndex: "application_date",
      render: (text: string) => formatLongDate(text),
      sorter: (a: any, b: any) =>
        dayjs(a.application_date).valueOf() - dayjs(b.application_date).valueOf(),
    },

    {
      title: "From",
      dataIndex: "from_date",
      render: (text: string) => formatLongDate(text),
      sorter: (a: any, b: any) =>
        dayjs(a.from_date).valueOf() - dayjs(b.from_date).valueOf(),
    },

    {
      title: "To",
      dataIndex: "to_date",
      render: (text: string) => formatLongDate(text),
      sorter: (a: any, b: any) =>
        dayjs(a.to_date || 0).valueOf() - dayjs(b.to_date || 0).valueOf(),
    }
    ,
    {
      title: "Days",
      dataIndex: "Days",
      sorter: (a: any, b: any) => a.Days - b.Days,
    },
    {
      title: "Type",
      dataIndex: "od_type",
      sorter: (a: any, b: any) => a.od_type.localeCompare(b.od_type),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text: string) => (
        <span
          className={`badge ${text.toLowerCase().includes("approved")
            ? "bg-success"
            : text.toLowerCase().includes("rejected")
              ? "bg-danger"
              : "bg-warning"
            }`}
        >
          {text}
        </span>
      ),
      sorter: (a: any, b: any) => a.status.localeCompare(b.status),
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (text: string, record: any) => (
        <div className="action-icon d-inline-flex">
          {/* Read/View Icon */}
          {record.status === "APPROVED" || record.status === "REJECTED" ? (
            <Link
              to="#"
              className="text-info"
              title="Read"
              data-bs-toggle="modal"
              data-bs-target={`${record.status === "APPROVED"
                ? "#approve-modal"
                : record.status === "REJECTED"
                  ? "#rejected-modal"
                  : "#apply-modal"
                } `}
              onClick={() => {
                setModalData(record);
              }}
            >
              <i className="ti ti-eye" />
            </Link>
          ) : (
            <>
              <Link
                to="#"
                className="text-info"
                title="Read"
                data-bs-toggle="modal"
                data-bs-target="#apply-modal"
                onClick={() => {
                  setModalData(record);
                }}
              >
                <i className="ti ti-eye" />
              </Link>
              {/* Approve Icon */}
              <Link
                to="#"
                className="text-success"
                title="Approve"
                onClick={() => {
                  approveLeaveRequest(record.od_application_id);
                }}
              >
                <i className="ti ti-circle-check" />
              </Link>

              {/* Disapprove Icon */}
              <Link
                to="#"
                className="text-danger"
                title="Rejected"
                onClick={() => {
                  rejectLeaveRequest(record.od_application_id);
                }}
              >
                <i className="ti ti-circle-x" />
              </Link>
            </>
          )}
        </div>
      ),
    },
  ];

  const {
    data: approve_data,
    loading: approverLoading,
    error,
    callApi: callApproveApi,
  } = useApi("/api/manager/update-od-request", {
    method: "POST",
    autoCall: false,
  });

  const approveLeaveRequest = async (odId: any) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to approve this Od request?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Approve",
      cancelButtonText: "Cancel",
    });

    // Proceed only if user confirms
    if (result.isConfirmed) {
      const payload = {
        od_id: odId,
        status: "APPROVED",
      };

      try {
        const response = await callApproveApi(payload);

        if (response.statusCode === 200 || response.statusCode === 201) {
          Swal.fire({
            icon: response.success === true ? "success" : "error",
            title:
              response.success === true ? "Leave Approved" : "Approval Failed",
            text:
              response?.message ||
              "The leave request has been approved successfully.",
            showConfirmButton: true,
          });
          setRefreshKey((prev) => prev + 1);
        }
      } catch (err: any) {
        console.error("Failed to approve leave:", err);
        Swal.fire({
          icon: "error",
          title: "Approval Failed",
          text:
            err?.response?.data?.message ||
            "Something went wrong while approving the leave.",
        });
      }
    }
  };

  const rejectLeaveRequest = async (odId: any) => {
    const result = await Swal.fire({
      title: "Reject Od Request",
      text: "Please provide a reason for rejection:",
      icon: "warning",
      input: "textarea",
      inputPlaceholder: "Enter detailed reason here...",
      inputAttributes: {
        "aria-label": "Rejection reason",
      },
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Reject",
      cancelButtonText: "Cancel",
      inputValidator: (value) => {
        if (!value.trim()) {
          return "Rejection reason is required!";
        }
        return null;
      },
    });

    if (result.isConfirmed && result.value) {
      const payload = {
        od_id: odId,
        status: "REJECTED",
        rejected_reason: result.value,
      };

      try {
        const response = await callApproveApi(payload);

        Swal.fire({
          icon: response.success === true ? "success" : "error",
          title:
            response.success === true ? "Leave Rejected" : "Rejection Failed",
          text: response?.message || "The leave request has been rejected.",
          showConfirmButton: true,
        });
        setRefreshKey((prev) => prev + 1);
      } catch (err: any) {
        console.error("Failed to reject leave:", err);
        Swal.fire({
          icon: "error",
          title: "Rejection Failed",
          text:
            err?.response?.data?.message ||
            "Something went wrong while rejecting the leave.",
          showConfirmButton: true,
        });
      }
    }
  };

  // First, define your statuses array (if not already defined)
  const statuses = [
    { value: "PENDING", label: "Pending Application" },
    { value: "APPROVED", label: "Approved Application" },
    { value: "REJECTED", label: "Rejected Application" },
  ];


  const handleBulkApprove = async (rows: any[]) => {
    if (!rows.length) {
      Swal.fire({
        icon: "warning",
        title: "No rows selected",
        text: "Please select at least one row to approve.",
      });
      return;
    }

    const result = await Swal.fire({
      title: "Approve OD Requests",
      text: `Are you sure you want to approve ${rows.length} od requests?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Approve",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return;

    try {
      for (const row of rows) {
        const payload = {
          od_id: row.od_application_id,
          status: "APPROVED",
        };

        await callApproveApi(payload);
      }

      Swal.fire({
        icon: "success",
        title: "Approved",
        text: `${rows.length} od requests approved successfully.`,
        showConfirmButton: true,
      });

      setRefreshKey(prev => prev + 1);

    } catch (error: any) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Approval Failed",
        text:
          error?.response?.data?.message ||
          "Something went wrong while approving od requests.",
      });
    }
  };


  const handleBulkReject = async (rows: any[]) => {
    if (!rows.length) {
      Swal.fire({
        icon: "warning",
        title: "No rows selected",
        text: "Please select at least one row to reject.",
      });
      return;
    }

    const result = await Swal.fire({
      title: "Reject OD Requests",
      input: "textarea",
      inputPlaceholder: "Enter rejection reason (required)",
      icon: "warning",
      inputAttributes: {
        "aria-label": "Rejection reason",
      },
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Reject",
      cancelButtonText: "Cancel",
      inputValidator: (value) => {
        if (!value.trim()) {
          return "Rejection reason is required!";
        }
        return null;
      },
    });

    if (!result.isConfirmed || !result.value) return;

    try {
      for (const row of rows) {
        const payload = {
          od_id: row.od_application_id,
          status: "REJECTED",
          rejected_reason: result.value,
        };

        await callApproveApi(payload);
      }

      Swal.fire({
        icon: "success",
        title: "Rejected",
        text: `${rows.length} od requests rejected successfully.`,
        showConfirmButton: true,
      });

      setRefreshKey(prev => prev + 1);

    } catch (error: any) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Rejection Failed",
        text:
          error?.response?.data?.message ||
          "Something went wrong while rejecting od requests.",
      });
    }
  };


  return (
    <>
      <Loader loading={odLoading || approverLoading} />
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Team Out Duty Status</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Work & Operations</li>
                  <li className="breadcrumb-item">OD</li>
                  <li className="breadcrumb-item">
                    <Link to={all_routes.teamOutDutyGrid}>Team Out Duty</Link>
                  </li>

                  <li className="breadcrumb-item active" aria-current="page">
                    Team Out Duty Status
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="me-2 mb-2"></div>
              <div className="input-icon w-120 position-relative mb-2">
                <span className="input-icon-addon">
                  <i className="ti ti-calendar text-gray-9" />
                </span>
              <select
                  value={finance_year}
                  onChange={(e) => setFinance_year(e.target.value)}
                  className="form-select"
                >
                  {getFinancialYearList().map((fy) => (
                    <option key={fy} value={fy}>
                      {fy.split("-")[0]}
                    </option>
                  ))}
                </select>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header">
              <div
                className="w-100"
                style={{
                  overflowX: "auto",
                  whiteSpace: "nowrap",
                  display: "flex",
                  justifyContent: "space-between"
                }}
              >
                <div
                  className="d-inline-flex align-items-center gap-2 px-1 py-2"
                  style={{ minWidth: "max-content" }}
                >
                  {statuses.map((status) => (
                    <button
                      key={status.value}
                      className="btn px-2 px-sm-4"
                      style={{
                        backgroundColor:
                          leavestatus === status.value ? "#2e3294" : "transparent",
                        color: leavestatus === status.value ? "#FFF" : "#2e3294",
                        border: "1px solid #2e3294",
                        borderRadius: "15px",
                        fontWeight: "500",
                        whiteSpace: "nowrap",
                      }}
                      onClick={() => handleLeaveStatusChange(status.value)}
                    >
                      {status.label}
                    </button>
                  ))}
                </div>
                {
                  leavestatus === "PENDING" ? <div className="d-flex gap-2">

                    <button
                      className="custom-btn-leave-approved"
                      onClick={() => handleBulkApprove(selectedRows)}
                    >
                      Approve
                    </button>
                    <button
                      className="custom-btn-leave-reject"
                      onClick={() => handleBulkReject(selectedRows)}
                    >
                      Reject
                    </button>
                  </div> : ""
                }

              </div>
            </div>


            <div className="card-body p-0">
              <Table dataSource={data} columns={columns} showSearchInput={true} Selection={leavestatus === "PENDING" ? true : false}
                rowKey={(record) => record.employee_id + record.od_application_id} onRowSelect={(rows) => setSelectedRows(rows)} />
            </div>
          </div>
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>

      <div
        id="apply-modal"
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="apply-modalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header  text-white">
              <h5 className="modal-title" id="apply-modalLabel">
                Pending OD Details
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-4 mb-3">
                  <strong>Employee ID:</strong>
                  <p className="text-muted">
                    {modalData?.employee_id || "N/A"}
                  </p>
                </div>
                <div className="col-md-4 mb-3">
                  <strong>Employee Name:</strong>
                  <p className="text-muted">
                    {modalData?.employee_name || "N/A"}
                  </p>
                </div>

                <div className="col-md-4 mb-3">
                  <strong>OD Type:</strong>
                  <p className="text-muted">{modalData?.od_type || "N/A"}</p>
                </div>

                <div className="col-md-4 mb-3">
                  <strong>OD Slice:</strong>
                  <p className="text-muted">
                    {modalData?.od_slice_type || "N/A"}
                  </p>
                </div>

                <div className="col-md-4 mb-3">
                  <strong>From Date:</strong>
                  <p className="text-muted">{formatLongDate(modalData?.from_date)}</p>
                </div>

                <div className="col-md-4 mb-3">
                  <strong>To Date:</strong>
                  <p className="text-muted">{formatLongDate(modalData?.to_date)}</p>
                </div>


                <div className="col-md-4 mb-3">
                  <strong>Number of Days:</strong>
                  <p className="text-muted">{modalData?.Days || "N/A"}</p>
                </div>

                <div className="col-md-4 mb-3">
                  <strong>Application Date:</strong>
                  <p className="text-muted">
                    {formatLongDate(modalData?.application_date)}
                  </p>
                </div>

                <div className="col-12 mb-3">
                  <strong>Reason:</strong>
                  <p className="text-muted">
                    {modalData?.application_reason || "N/A"}
                  </p>
                </div>
                <div className="col-md-4 mb-3">
                  <strong>CC Email:</strong>
                  <p className="text-muted">{modalData?.cc_email || "N/A"}</p>
                </div>

                <div className="col-md-4 mb-3">
                  <strong>Status:</strong>
                  <p>
                    <span
                      className={`badge ${modalData?.status === "APPROVED"
                        ? "bg-success"
                        : modalData?.status === "REJECTED"
                          ? "bg-danger"
                          : "bg-warning text-dark"
                        }`}
                    >
                      {modalData?.status || "PENDING"}
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* modal */}

      <div
        id="approve-modal"
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="approve-modalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header  text-white">
              <h5 className="modal-title" id="approve-modalLabel">
                OD Application Approved
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <strong>Approved By:</strong>
                <p className="mb-0 text-muted">
                  {modalData?.approved_by_name === null
                    ? modalData?.approved_by
                    : modalData?.approved_by_name}
                </p>
              </div>

              <div className="mb-3">
                <strong>Approved On:</strong>
                <p className="mb-0 text-muted">
                  {modalData?.approved_on
                    ? dayjs(modalData.approved_on).format("DD-MMMM-YYYY hh:mm A")
                    : "N/A"}
                </p>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Rejected  */}
      <div
        id="rejected-modal"
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="rejected-modalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header text-white">
              <h5 className="modal-title" id="rejected-modalLabel">
                OD Application Rejected
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <strong>Rejected By:</strong>
                <p className="mb-0 text-muted">
                  {modalData?.rejected_by_name === null
                    ? modalData?.rejected_by
                    : modalData?.rejected_by_name}
                </p>
              </div>

              <div className="mb-3">
                <strong>Rejection Reason:</strong>
                <p className="mb-0 text-muted">
                  {modalData?.rejection_reason || "N/A"}
                </p>
              </div>

              <div className="mb-3">
                <strong>Rejected On:</strong>
                <p className="mb-0 text-muted">
                  {modalData?.rejected_on
                    ? dayjs(modalData.rejected_on).format("DD-MMMM-YYYY hh:mm A")
                    : "N/A"}
                </p>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OutdutyTeamStatus;
